export default __webpack_public_path__ + "static/media/IMG_1064.d25e88f6.d25e88f6.JPG";